
export const HeaderCellDefaultTable = ({ 
    children, 
    left, 
    sticky, 
    width,
    className = "",
}) => {
    const normalizedChildren = (Array.isArray(children) ? children : [children])
        .map((child) => (typeof child === "string" ? child.trim() : child))
        .filter(
            (child) =>
                child !== null &&
                child !== undefined &&
                !(typeof child === "string" && child.length === 0)
        );

    if (normalizedChildren.length === 0) {
        return null;
    }

    return (
        <th
            scope="col"
            className={`box-border border-b border-gray-200 bg-white px-2 py-2 text-[11px] font-semibold uppercase tracking-wide text-gray-600 whitespace-nowrap ${className || "text-left"} ${
                sticky ? "sticky z-20 shadow-[1px_0_0_0_#e5e7eb]" : ""
            }`}
            style={{
                minWidth: width,
                left: sticky ? left : undefined,
                boxSizing: "border-box",
            }}
        >
            {normalizedChildren.length === 1 ? normalizedChildren[0] : normalizedChildren}
        </th>
    );
};